// src/pages/Clients.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = 'https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod';

function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const email = localStorage.getItem('user_email');
        if (!email) return;

        const userRes = await fetch(`${API_URL}/users/email/${encodeURIComponent(email)}`);
        const user = await userRes.json();
        const professionalId = user.user_id;

        const res = await fetch(`${API_URL}/professionals/${professionalId}/clients`);
        const data = await res.json();

        setClients(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Erreur récupération des clients :', err);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  return (
    <div style={{ padding: '2rem' }}>
      <h2 style={{ marginBottom: '10px' }}>Mes clients</h2>

      <button
        onClick={() => navigate('/professional/dashboard')}
        style={btnSecondary}
      >
        ⬅️ Retour au dashboard
      </button>

      {loading ? (
        <p>Chargement…</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={thStyle}>Prénom</th>
                <th style={thStyle}>Nom</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Téléphone</th>
                <th style={thStyle}>Date de naissance</th>
                <th style={thStyle}>Actions</th>
                <th style={thStyle}>Télémédecine</th> {/* 🆕 Nouvelle colonne */}
              </tr>
            </thead>
            <tbody>
              {clients.map(client => (
                <tr key={client.patient_id}>
                  <td style={tdStyle}>{client.first_name}</td>
                  <td style={tdStyle}>{client.last_name}</td>
                  <td style={tdStyle}>{client.email}</td>
                  <td style={tdStyle}>{client.phone || '—'}</td>
                  <td style={tdStyle}>{client.birth_date || '—'}</td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => navigate(`/professional/clients/${client.patient_id}`)}
                      style={btnPrimary}
                    >
                      Voir le profil
                    </button>
                  </td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => navigate(`/professional/clients/${client.patient_id}/telemed`)}
                      style={btnPurple}
                      title="Voir les sessions de téléconsultation (transcription, vidéo, résumé)"
                    >
                      📹 Sessions
                    </button>
                  </td>
                </tr>
              ))}
              {clients.length === 0 && (
                <tr>
                  <td colSpan={7} style={{ padding: '14px', textAlign: 'center', color: '#666' }}>
                    Aucun client pour l’instant.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const thStyle = {
  border: '1px solid #eee',
  padding: '10px',
  textAlign: 'left',
  fontWeight: 600
};

const tdStyle = {
  border: '1px solid #f3f3f3',
  padding: '10px'
};

const btnPrimary = {
  backgroundColor: '#1976d2',
  color: '#fff',
  border: 'none',
  padding: '6px 12px',
  borderRadius: '6px',
  cursor: 'pointer'
};

const btnSecondary = {
  backgroundColor: '#888',
  color: '#fff',
  border: 'none',
  padding: '8px 12px',
  borderRadius: '6px',
  cursor: 'pointer',
  marginBottom: '14px'
};

const btnPurple = {
  backgroundColor: '#6c43f3',
  color: '#fff',
  border: 'none',
  padding: '6px 12px',
  borderRadius: '6px',
  cursor: 'pointer'
};

export default Clients;